import { setUse24HourFormat, setUseUtcTime } from '@admin-slice';
import { Box, FormControlLabel, FormGroup, Popover, Switch } from '@mui/material';
import { RootState } from '@store';

import { useCallback } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

export interface FilterPopoverProps {
  anchor: null | HTMLElement;
  onClose: () => void;
}

const SettingsPopover = ({ anchor, onClose }: FilterPopoverProps) => {
  const dispatch = useDispatch();
  const { useUtcTime, use24HourFormat } = useSelector(
    (state: RootState) => ({
      useUtcTime: state.admin.useUtcTime,
      use24HourFormat: state.admin.use24HourFormat
    }),
    shallowEqual
  );
  const onUseUtcTimeChanged = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(setUseUtcTime(e.target.checked));
    },
    [dispatch]
  );
  const onUse24HourFormatChanged = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(setUse24HourFormat(e.target.checked));
    },
    [dispatch]
  );
  return (
    <Popover
      open={Boolean(anchor)}
      anchorEl={anchor}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          p: 2,
          userSelect: 'none'
        }}
      >
        <FormGroup>
          <FormControlLabel control={<Switch onChange={onUse24HourFormatChanged} checked={use24HourFormat} />} label="24-Hour Format" />
          <FormControlLabel control={<Switch onChange={onUseUtcTimeChanged} checked={useUtcTime} />} label="UTC Time" />
        </FormGroup>
      </Box>
    </Popover>
  );
};
export default SettingsPopover;
